import type { FaireProductEntity } from "../../entity_types/product";

export const driftless_studios_13: FaireProductEntity = {
  token: "driftless-studios-13",
  type: "product",
  name: "12 Ounce Jingle Juice Christmas Mug",
  brandName: "Driftless Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/9bfb5905d36a108401f956c7e152c299c65e180c4bee532732cc41537b16341b.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 14.5,
  msrpDollars: 26,
  freeShipping: true,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_proto_home-and-living"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
